import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { H2, P } from 'components/Ui';
import { getToUrl } from 'utils/translation';
import { SKIP_EQUIPMENT } from '../constants';
import PromotionValidation from '../PromotionValidation';
import content from '../quickShopContent';
import styles from './styles.scss';

const SkipEquipmentFooter = ({
  step,
  promotionApplied,
  cartItems,
  isCostco,
  disableNext,
}) => {
  const skipEquipmentContent = content[SKIP_EQUIPMENT];
  return (
    <div className={styles.skipEquipment}>
      <div className={styles.contentContainer}>
        <H2 className={styles.title}>{skipEquipmentContent.title}</H2>
        <P className={styles.note}>{skipEquipmentContent.note}</P>
        <div className={styles.reviewCart}>
          {isCostco ? (
            <Link to={getToUrl('/cart', 'U37')} disabled={disableNext}>
              {skipEquipmentContent.buttonLabel}
            </Link>
          ) : (
            <PromotionValidation
              buttonLabel={skipEquipmentContent.buttonLabel}
              promotionApplied={promotionApplied}
              step={step}
              cartItems={cartItems}
              reviewCart
            />
          )}
        </div>
      </div>
    </div>
  );
};

SkipEquipmentFooter.propTypes = {
  step: PropTypes.number,
  promotionApplied: PropTypes.bool,
  cartItems: PropTypes.array,
  isCostco: PropTypes.bool,
  disableNext: PropTypes.bool,
};

export default memo(SkipEquipmentFooter);
